import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithToken } = useApp();
  const processed = useRef(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/"); return; }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        loginWithToken(res.data.token, res.data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        setError(true);
        setTimeout(() => navigate("/"), 1500);
      }
    })();
  }, []);

  return (
    <div className="mx-auto max-w-md min-h-[100dvh] flex flex-col items-center justify-center gap-4" style={{ background: "var(--app-bg)" }}>
      <Logo className="h-14 animate-pulse" />
      <p className="font-heading text-gray-600">{error ? "Anmeldung fehlgeschlagen…" : "Anmeldung läuft…"}</p>
    </div>
  );
}
